<template>
	<div>
		<div class="tab_header">
			<a class="active" href="#block-1">Все</a>
			<a href="#block-2">LIVE</a>
			<a href="#block-3">Завершено</a>
			<a class="disabled" href="">
				<span>Календарь</span>
			</a>
		</div>
		
		<div class="datepicker-block">
			<datepicker @dateSelected="dateSelected" :type="type"></datepicker>
		</div>
	</div>
</template>

<script>
	import Datepicker from "../Datepicker/Datepicker";
	
	export default {
		props: ['type'],
		
		components: {
			Datepicker
		},
		
		methods: {
			dateSelected(date) {
				this.$emit('dateSelected', date);
				
				$('.datepicker-block').removeClass('active');
			}
		}
	}
</script>

<style scoped>

</style>